export const FILTER_CACHE_PREFIX = 'filterCache:';

export function clearAllFilterCaches(): void {
  try {
    const keys = Object.keys(localStorage).filter(k => k.startsWith(FILTER_CACHE_PREFIX));
    keys.forEach(k => localStorage.removeItem(k));
  } catch {
    // ignore storage errors
  }
}


